<script setup>
  const props = defineProps({
    item: Array // O ideal é mudar para Array, pois os artigos são uma lista
  });

  const emit = defineEmits(['apply']);
</script>

<template>
  <!-- Mudámos para card.id ou card.title para a key -->
  <div class="container-card" v-for="card in item" :key="card.id || card.title">
    <div class="card">
      <div class="card-image">
        <img v-if="card.featured_image" :src="card.featured_image.fullUrl" alt="">
        <img v-else src="/images/No-image-2.jpg" alt="">
      </div>
      <h4>{{ card.title }}</h4>
      <div class="card-text">
        <div v-html="card.content"></div>
        <!-- CORRIGIDO: Passar 'card.title' em vez de 'article.title' -->
        <button type="button" @click="$emit('apply', card.title)">Apply</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
